import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';
import { Link } from '@commons/i18n/navigation';
import type { SiteAlert as Props } from '@commons/services/alert';

import styles from './Alert.module.scss';

/**
 * SiteAlert component.
 */

const SiteAlert = ({ bannerTitle, bannerContent, alias }: Props) => (
  <Link href={alias} className={styles.alert}>
    <BaseContainer width={{ xs: 10, lg: 12 }} paddingLeft="sm" paddingRight="sm" className="h-100">
      <Text level="h4">{bannerTitle}</Text>
      {bannerContent && (
        <Text level="body-sm" marginBottom="none">
          {bannerContent}
        </Text>
      )}
    </BaseContainer>
  </Link>
);

export default SiteAlert;
